/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationStateTown } from './OrganizationStateTown';
import {
    OrganizationStateTownFromJSON,
    OrganizationStateTownFromJSONTyped,
    OrganizationStateTownToJSON,
} from './OrganizationStateTown';

/**
 * 
 * @export
 * @interface CreateOrganizationStateTownsBulkRequest
 */
export interface CreateOrganizationStateTownsBulkRequest {
    /**
     * 
     * @type {Array<OrganizationStateTown>}
     * @memberof CreateOrganizationStateTownsBulkRequest
     */
    organization_state_towns?: Array<OrganizationStateTown>;
}

/**
 * Check if a given object implements the CreateOrganizationStateTownsBulkRequest interface.
 */
export function instanceOfCreateOrganizationStateTownsBulkRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateOrganizationStateTownsBulkRequestFromJSON(json: any): CreateOrganizationStateTownsBulkRequest {
    return CreateOrganizationStateTownsBulkRequestFromJSONTyped(json, false);
}

export function CreateOrganizationStateTownsBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationStateTownsBulkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization_state_towns': !exists(json, 'organization_state_towns') ? undefined : ((json['organization_state_towns'] as Array<any>).map(OrganizationStateTownFromJSON)),
    };
}

export function CreateOrganizationStateTownsBulkRequestToJSON(value?: CreateOrganizationStateTownsBulkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_state_towns': value.organization_state_towns === undefined ? undefined : ((value.organization_state_towns as Array<any>).map(OrganizationStateTownToJSON)),
    };
}

